import E3Select from './ui/e3-select/e3-select';
import E3CloseButton from './ui/e3-close-button/e3-close-button';
import E3Loading from './ui/e3-loading';

// Named re-exports so `import {E3CloseButton} from '../ui'` keeps working
export { E3Select, E3CloseButton, E3Loading };

// Lightweight factory for viewer UI components.
// floatingBtn() mounts to document.body and returns { remove() }.
// btn() returns a plain <button> element for insertion into any container.
const UI = {
  floatingBtn(label, onClick, {
    wrapperClass = 'museum-scene-end-mini',
    btnClass     = 'museum-scene-end-mini__btn',
  } = {}) {
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    const btn = UI.btn(label, onClick, btnClass);
    wrapper.appendChild(btn);
    document.body.appendChild(wrapper);
    return {
      remove() {
        if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
      },
    };
  },

  modal({ onBackdropClick, message, overlayClass = 'museum-scene-end', containerClass = 'museum-scene-end__container', backdropClass = 'museum-scene-end__backdrop', msgClass = 'museum-scene-end__msg', actionsClass = 'museum-scene-end__actions' } = {}) {
    const overlay = document.createElement('div');
    overlay.className = overlayClass;

    const backdrop = document.createElement('div');
    backdrop.className = backdropClass;
    if (onBackdropClick) backdrop.addEventListener('click', onBackdropClick);
    overlay.appendChild(backdrop);

    const container = document.createElement('div');
    container.className = containerClass;
    container.addEventListener('click', e => e.stopPropagation());

    if (message) {
      const msg = document.createElement('p');
      msg.className = msgClass;
      msg.textContent = message;
      container.appendChild(msg);
    }

    const actions = document.createElement('div');
    actions.className = actionsClass;
    container.appendChild(actions);
    overlay.appendChild(container);
    document.body.appendChild(overlay);

    return {
      overlay,
      actions,
      remove() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      },
    };
  },

  animatedFill(duration, onEnd, className = 'museum-scene-end__btn-next-fill') {
    const fill = document.createElement('div');
    fill.className = className;
    fill.style.setProperty('--scene-end-duration', `${duration}ms`);
    fill.addEventListener('animationend', onEnd);
    return fill;
  },

  btn(label, onClick, className = '') {
    const btn = document.createElement('button');
    btn.type = 'button';
    if (className) btn.className = className;
    if (label) btn.textContent = label;
    btn.addEventListener('click', onClick);
    return btn;
  },
};

export default UI;
